import { Component, OnInit, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SessionService } from 'src/app/shared/services/session.service';
import { environment } from 'src/environments/environment';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
    selector: 'booking-widget-shell',
    templateUrl: './booking-widget-shell.component.html',
    styleUrl: './booking-widget-shell.component.scss',
    standalone: false
})
export class BookingWidgetShellComponent implements OnInit {
  public url: SafeResourceUrl;
  public iframeCodeHtml: string;
  private clipboard: Clipboard = inject(Clipboard);
  private snackBarService = inject(MatSnackBar);

  constructor(private sessionService: SessionService,
    private sanitizer: DomSanitizer) {

  }

  ngOnInit(): void {
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.dashboardLocation}/booking-widget?apiKey=${this.sessionService.getUser().apiKey}`);
    this.iframeCodeHtml = `<iframe src="${environment.dashboardLocation}/booking-widget?apiKey=${this.sessionService.getUser().apiKey}" width="600" height="740"></iframe>`;
  }

  copyText() {
    const htmlToCopy = this.iframeCodeHtml; // Assuming iframeCodeHtml holds the HTML content
    const pending = this.clipboard.beginCopy(htmlToCopy);
    let remainingAttempts = 3;

    if (pending.copy()) {
      pending.destroy();
      this.snackBarService.open('Text Copied!', 'Close', { // Assuming snackBarService for notifications
        horizontalPosition: 'center',
        verticalPosition: 'top',
        duration: 5 * 1000,
      });
    } else {
      if (!remainingAttempts) {
        pending.destroy();
        this.snackBarService.open('Failed to copy text. Please try again.', null, {
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 5 * 1000
        });
        return;
      }
      remainingAttempts--;
    }
  }

}
